<template>
  <div class="page invite-repairer">
    <div class="auth-header">
      <div class="container">
        <div class="logo">
          <router-link to="/login" class="logo-link"></router-link>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="invite-repairer-form text-center">
        <div class="intro-text">
          <div class="big-icon">
            <h1>We Found a Problem</h1>
            <i class="bx bxs-sad" style="color:#5E7CCC; font-size: 73px;"></i>
          </div>
          <h3>The account you are trying to setup may already exist under this email address.</h3>
        </div>
        <div class="frame">
          Think you may registered an account with us before?
          <router-link
            :to="'/register/find-account'"
          >Help me find my account</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "InviteFoundProblem",
    components: {}
  };
</script>

<style scoped>
.frame {
  margin-top: 50px;
  line-height: 26px;
  font-size: 16px;
  font-weight: 600;
}

.intro-text {
  line-height: 26px;
}
.big-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 50px;
  color: #5E79FF;
}
.big-icon i {
  margin-left: 30px;
}
h1 {
  font-weight: bold;
  margin-bottom: 15px;
}

  .invite-repairer-form h3 {
    max-width: 500px;
    margin: 0 auto;
    margin-top: 50px;
    font-size: 32px;
  }

  .auth-header {
    background-color: #1f233d;
    height: 100px;
  }

  .logo-text {
    color: white;
  }

  .container {
    height: 100%;
  }

  .logo {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .steps-line ul {
    display: flex;
    justify-content: space-around;
    list-style-type: none;
  }

  .numb {
    display: none;
  }

  .form hr {
    margin-top: 50px;
    height: 1px;
    background-color: #1f233d;
  }

  .active {
    color: #5E79FF;
    font-weight: bold;
  }

  .custom-multiselect {
    margin: 0 auto;
    width: 70%;
  }

  .input-btn {
    background: #4472C4;
  }

  .logo-link {
        display: block;
        height: 42px;
        width: 200px;
        background: url('data:image/gif;base64,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')
    }

</style>
